export const adminConfirmedPages = ['search'];
